import { PropsWithChildren, useContext } from "react";
import cx from "classnames";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import styles from "./Tooltip.module.scss";
import { radixThemeDataAttributes } from "@/components/Theme";

function Trigger({ children }: PropsWithChildren) {
  return (
    <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
  );
}

interface ContentProps {
  align?: "start" | "center" | "end";
  alignOffset?: number;
  side?: "top" | "right" | "bottom" | "left";
  sideOffset?: number;
  collisionPadding?: number;
}

function Content({
  children,
  align = "start",
  alignOffset = -4,
  side = "bottom",
  sideOffset = 4,
  collisionPadding = 16,
}: PropsWithChildren<ContentProps>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        className={cx(styles.TooltipContent, "radix-themes")}
        sideOffset={sideOffset}
        alignOffset={alignOffset}
        side={side}
        align={align}
        collisionPadding={collisionPadding}
        {...radixThemeDataAttributes}
      >
        {children}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

function Tooltip({ children }: PropsWithChildren) {
  return (
    <TooltipPrimitive.Root delayDuration={100}>
      {children}
    </TooltipPrimitive.Root>
  );
}

Tooltip.Trigger = Trigger;
Tooltip.Content = Content;

export default Tooltip;
